var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.assignments.length)?_vm._t("headline"):_vm._e(),_vm._v(" "),(_vm.assignments.length)?_c('ul',{class:['assignment-items', { 'is-odd': ((_vm.assignments.length+1) % 2 === 0) }]},_vm._l((_vm.assignments),function(blast){return _c('assignment-item',{key:blast.id,attrs:{"blast":blast}})})):_c('div',[_vm._t("empty")],2)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45a7193b","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AssignmentList/index.vue
// module id = null
// module chunks = 